import type { FC, ReactNode } from "react";
import "./buttonLayout.scss";

interface Props {
  children: ReactNode;
  smFixed?: boolean;
}

const ButtonLayout: FC<Props> = (props) => {
  const { children, smFixed = true } = props;

  return <div className={`buttonLayout ${smFixed ? "smFixed" : ""}`}>{children}</div>;
};

export default ButtonLayout;
